import React from "react";
import { AiFillInstagram, AiFillFacebook } from "react-icons/ai";

const Footer = () => {
  return (
    <div className="flex justify-center flex-col items-center gap-2 my-10">
      <p className="text-lg font-bold text-gray-500">
        2023 NeXT Gadget All Rights Reserverd
      </p>
      <p className="flex gap-1">
        <a href="https://instagram.com/nextgadgetshop" target={"_blank"}>
          <AiFillInstagram className="text-2xl font-semibold text-gray-500 cursor-pointer" />
        </a>
        <a href="https://www.facebook.com/NextGadgetShopMM" target={"_blank"}>
          <AiFillFacebook className="text-2xl font-semibold text-gray-500 cursor-pointer" />
        </a>
      </p>
    </div>
  );
};

export default Footer;
